export default {"src":"/_next/static/media/paginarition-arrow-left.fc29bd86.svg","height":24,"width":25,"blurWidth":0,"blurHeight":0};